var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.019 392.098L299.385 255.837L446.218 120.321C458.192 109.264 458.192 91.3397 446.218 80.2885C434.237 69.2372 414.823 69.2372 402.842 80.2885L256.009 215.804L109.182 80.2885C97.2011 69.2372 77.7865 69.2372 65.8057 80.2885C53.825 91.3458 53.825 109.27 65.8057 120.321L212.632 255.837L64.9856 392.098C53.0048 403.156 53.0048 421.074 64.9856 432.131C70.976 437.66 78.8232 440.421 86.6769 440.421C94.5307 440.421 102.378 437.66 108.368 432.131L256.009 295.87L403.642 432.131C409.633 437.66 417.48 440.421 425.334 440.421C433.187 440.421 441.035 437.66 447.025 432.131C458.993 421.08 458.993 403.156 447.019 392.098Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenuClose);
export default __webpack_public_path__ + "static/media/ico_menu_close.dbf86f1262864fd31af96e04acdb29f8.svg";
export { ForwardRef as ReactComponent };